module.exports = __webpack_public_path__ + "media/components/country-flag/static/bi-af1996f2f848f72038946ea37fd7ac9b.svg";